
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tester-club",
      function () {
        return require("private-next-pages/tester-club.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tester-club"])
      });
    }
  